/**
 * Torso outfit textures: alien-elemental-1
 */
export function drawTorso_lava_suit(ctx, size, _options = {}) {
  // TRANG PHỤC GIÁP NHAM THẠCH LỬA (Magma Armor)
  ctx.fillStyle = '#7f1d1d';
  ctx.fillRect(0, 0, size, size);

  // Các mạch nứt dung nham nóng đỏ
  ctx.strokeStyle = '#f97316';
  ctx.lineWidth = size * 0.035;
  ctx.beginPath();
  ctx.moveTo(size * 0.2, 0);
  ctx.lineTo(size * 0.35, size * 0.35);
  ctx.lineTo(size * 0.5, size * 0.45);
  ctx.lineTo(size * 0.65, size * 0.8);
  ctx.moveTo(size * 0.8, size * 0.1);
  ctx.lineTo(size * 0.65, size * 0.45);
  ctx.lineTo(size * 0.3, size * 0.7);
  ctx.stroke();

  // Lõi dung nham giữa ngực
  ctx.fillStyle = '#facc15';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.45, size * 0.1, 0, Math.PI * 2);
  ctx.fill();
}

export function drawTorso_mech_armor(ctx, size, _options = {}) {
  // GIÁP CHIẾN BINH CƠ GIỚI MECHA
  ctx.fillStyle = '#0f172a';
  ctx.fillRect(0, 0, size, size);

  // Tấm giáp titan ngực xám bạc
  ctx.fillStyle = '#334155';
  ctx.fillRect(size * 0.15, size * 0.18, size * 0.7, size * 0.64);

  // Đường viền neon cyan
  ctx.strokeStyle = '#38bdf8';
  ctx.lineWidth = size * 0.02;
  ctx.strokeRect(size * 0.15, size * 0.18, size * 0.7, size * 0.64);

  // Lõi lò phản ứng hồ quang (Arc Reactor) tròn ở giữa
  ctx.fillStyle = '#0284c7';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.45, size * 0.14, 0, Math.PI * 2);
  ctx.fill();
  ctx.fillStyle = '#f0f9ff';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.45, size * 0.07, 0, Math.PI * 2);
  ctx.fill();
}

export function drawTorso_astral_robe(ctx, size, _options = {}) {
  // ÁO CHOÀNG TINH TÚ NGÂN HÀ (Astral Robe)
  const astralGrad = ctx.createLinearGradient(0, 0, 0, size);
  astralGrad.addColorStop(0, '#1e1b4b');
  astralGrad.addColorStop(0.5, '#312e81');
  astralGrad.addColorStop(1, '#4338ca');
  ctx.fillStyle = astralGrad;
  ctx.fillRect(0, 0, size, size);

  // Viền dải vàng hoàng kim cổ áo và vạt giữa
  ctx.fillStyle = '#facc15';
  ctx.fillRect(size * 0.46, 0, size * 0.08, size);

  // Sao li ti trên áo
  ctx.fillStyle = '#ffffff';
  [
    { x: 0.25, y: 0.3 },
    { x: 0.75, y: 0.25 },
    { x: 0.3, y: 0.7 },
    { x: 0.7, y: 0.75 }
  ].forEach((sp) => {
    ctx.fillRect(size * sp.x, size * sp.y, size * 0.03, size * 0.03);
  });
}

export function drawTorso_cryo_plate(ctx, size, _options = {}) {
  // GIÁP BĂNG TINH THỂ (Cryo Armor)
  ctx.fillStyle = '#0284c7';
  ctx.fillRect(0, 0, size, size);

  // Các mảng đa giác băng nứt
  ctx.strokeStyle = '#e0f2fe';
  ctx.lineWidth = size * 0.025;
  ctx.beginPath();
  ctx.moveTo(size * 0.5, size * 0.15);
  ctx.lineTo(size * 0.8, size * 0.4);
  ctx.lineTo(size * 0.65, size * 0.8);
  ctx.lineTo(size * 0.35, size * 0.8);
  ctx.lineTo(size * 0.2, size * 0.4);
  ctx.closePath();
  ctx.stroke();

  // Hoa tuyết tâm giữa
  ctx.fillStyle = '#bae6fd';
  ctx.fillRect(size * 0.48, size * 0.3, size * 0.04, size * 0.25);
  ctx.fillRect(size * 0.38, size * 0.405, size * 0.24, size * 0.04);
}

export function drawTorso_bio_suit(ctx, size, _options = {}) {
  // GIÁP SINH HỌC DIỆP LỤC & KITIN (Bio Suit)
  ctx.fillStyle = '#065f46';
  ctx.fillRect(0, 0, size, size);

  // Các múi cơ/đốt giáp sinh học
  ctx.strokeStyle = '#10b981';
  ctx.lineWidth = size * 0.02;
  [0.25, 0.45, 0.65].forEach((ySeg) => {
    ctx.beginPath();
    ctx.arc(size * 0.5, size * ySeg, size * 0.3, 0, Math.PI);
    ctx.stroke();
  });

  // Hạch sinh học trung tâm phát quang
  ctx.fillStyle = '#34d399';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.45, size * 0.08, 0, Math.PI * 2);
  ctx.fill();
}

export function drawTorso_magma_male(ctx, size, _options = {}) {
  // 1. ÁO VẠT CHÉO NỨT NẺ MẠCH DUNG NHAM CHẢY RỰC CAM (IGNIS PRIME - MALE)
  ctx.fillStyle = '#1c1917';
  ctx.fillRect(0, 0, size, size);

  // Vạt áo chéo chiến binh nham thạch
  ctx.fillStyle = '#3f1111';
  ctx.beginPath();
  ctx.moveTo(size * 0.15, 0);
  ctx.lineTo(size * 0.85, 0);
  ctx.lineTo(size * 0.95, size);
  ctx.lineTo(size * 0.35, size);
  ctx.closePath();
  ctx.fill();

  // Nẹp viền vạt chéo
  ctx.strokeStyle = '#7f1d1d';
  ctx.lineWidth = size * 0.025;
  ctx.beginPath();
  ctx.moveTo(size * 0.15, 0);
  ctx.lineTo(size * 0.35, size);
  ctx.stroke();

  // Các mạch dung nham nứt nẻ rực cam
  const drawLavaCrack = (pts) => {
    ctx.strokeStyle = 'rgba(239, 68, 68, 0.45)';
    ctx.lineWidth = size * 0.055;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.beginPath();
    pts.forEach((p, idx) => (idx === 0 ? ctx.moveTo(size * p[0], size * p[1]) : ctx.lineTo(size * p[0], size * p[1])));
    ctx.stroke();

    ctx.strokeStyle = '#f97316';
    ctx.lineWidth = size * 0.032;
    ctx.stroke();

    ctx.strokeStyle = '#fef08a';
    ctx.lineWidth = size * 0.012;
    ctx.stroke();
  };

  drawLavaCrack([
    [0.25, 0.05],
    [0.38, 0.28],
    [0.52, 0.45],
    [0.46, 0.65],
    [0.6, 0.82],
    [0.55, 0.95]
  ]);
  drawLavaCrack([
    [0.52, 0.45],
    [0.72, 0.5],
    [0.85, 0.68]
  ]);
  drawLavaCrack([
    [0.38, 0.28],
    [0.2, 0.42],
    [0.12, 0.55]
  ]);

  // Thắt lưng bazan đá nham thạch ở eo
  ctx.fillStyle = '#0c0a09';
  ctx.fillRect(0, size * 0.78, size, size * 0.12);
  ctx.fillStyle = '#ea580c';
  ctx.fillRect(size * 0.4, size * 0.76, size * 0.2, size * 0.16);
  ctx.fillStyle = '#fde047';
  ctx.fillRect(size * 0.44, size * 0.79, size * 0.12, size * 0.1);
}

export function drawTorso_magma_female(ctx, size, options = {}) {
  // 2. ÁO CHOÀNG ÔM EO CÓ VÂN HOA LỬA NHAM THẠCH (IGNIS PRIME - FEMALE)
  const magmaGrad = ctx.createLinearGradient(0, 0, 0, size);
  magmaGrad.addColorStop(0, '#7f1d1d');
  magmaGrad.addColorStop(0.5, '#450a0a');
  magmaGrad.addColorStop(1, '#1c1917');
  ctx.fillStyle = magmaGrad;
  ctx.fillRect(0, 0, size, size);

  // Chiết eo ôm dáng hai bên hông
  ctx.fillStyle = '#1c1917';
  ctx.beginPath();
  ctx.moveTo(0, 0);
  ctx.lineTo(size * 0.18, 0);
  ctx.quadraticCurveTo(size * 0.26, size * 0.65, size * 0.12, size);
  ctx.lineTo(0, size);
  ctx.closePath();
  ctx.fill();

  ctx.beginPath();
  ctx.moveTo(size, 0);
  ctx.lineTo(size * 0.82, 0);
  ctx.quadraticCurveTo(size * 0.74, size * 0.65, size * 0.88, size);
  ctx.lineTo(size, size);
  ctx.closePath();
  ctx.fill();

  // Cổ áo chữ V quyến rũ
  ctx.fillStyle = options.skinColor || '#fcd5b5';
  ctx.beginPath();
  ctx.moveTo(size * 0.35, 0);
  ctx.lineTo(size * 0.5, size * 0.22);
  ctx.lineTo(size * 0.65, 0);
  ctx.closePath();
  ctx.fill();

  ctx.strokeStyle = '#f59e0b';
  ctx.lineWidth = size * 0.018;
  ctx.stroke();

  // Vân hoa lửa nham thạch uốn lượn
  ctx.strokeStyle = '#f97316';
  ctx.lineWidth = size * 0.022;
  ctx.beginPath();
  ctx.moveTo(size * 0.5, size * 0.3);
  ctx.bezierCurveTo(size * 0.32, size * 0.35, size * 0.28, size * 0.52, size * 0.38, size * 0.62);
  ctx.bezierCurveTo(size * 0.44, size * 0.7, size * 0.35, size * 0.85, size * 0.45, size * 0.92);
  ctx.moveTo(size * 0.5, size * 0.3);
  ctx.bezierCurveTo(size * 0.68, size * 0.35, size * 0.72, size * 0.52, size * 0.62, size * 0.62);
  ctx.bezierCurveTo(size * 0.56, size * 0.7, size * 0.65, size * 0.85, size * 0.55, size * 0.92);
  ctx.stroke();

  // Cánh hoa dung nham
  const flowerPoints = [
    [0.5, 0.3],
    [0.38, 0.62],
    [0.62, 0.62],
    [0.5, 0.75]
  ];
  flowerPoints.forEach((fp) => {
    ctx.fillStyle = '#fbbf24';
    ctx.beginPath();
    ctx.arc(size * fp[0], size * fp[1], size * 0.035, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = '#ef4444';
    ctx.beginPath();
    ctx.arc(size * fp[0], size * fp[1], size * 0.018, 0, Math.PI * 2);
    ctx.fill();
  });

  // Bụi tàn lửa li ti
  ctx.fillStyle = '#fde047';
  [
    [0.3, 0.25],
    [0.7, 0.25],
    [0.26, 0.78],
    [0.74, 0.78],
    [0.5, 0.52]
  ].forEach((pt) => {
    ctx.beginPath();
    ctx.arc(size * pt[0], size * pt[1], size * 0.015, 0, Math.PI * 2);
    ctx.fill();
  });
}

export const alien_elemental_1_drawers = {
  lava_suit: drawTorso_lava_suit,
  mech_armor: drawTorso_mech_armor,
  astral_robe: drawTorso_astral_robe,
  cryo_plate: drawTorso_cryo_plate,
  bio_suit: drawTorso_bio_suit,
  magma_male: drawTorso_magma_male,
  magma_female: drawTorso_magma_female
};
